export function maybeFocusASearchBox(alsoEnableSettingsToggle = false) {
  const searchBox = document.querySelector(
    ".properties-panel-search-box-wrap input"
  ) as HTMLElement | null;
  searchBox?.focus();

  if (alsoEnableSettingsToggle) {
    const settingsToggle = document.querySelector(
      ".properties-panel-search-box-wrap .properties-panel-search-settings-toggle"
    ) as HTMLElement | null;

    if (settingsToggle) {
      const event = new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window
      });
      settingsToggle.dispatchEvent(event);
    }
  }
}

export function maybeEnableSearchBoxModifiedToggle() {
  const modifiedToggle = document.querySelector(
    ".properties-panel-search-box-wrap .properties-panel-search-modified"
  ) as HTMLElement | null;

  if (modifiedToggle) {
    const event = new MouseEvent("click", {
      bubbles: true,
      cancelable: true,
      view: window
    });
    modifiedToggle.dispatchEvent(event);
  }
}
